import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=4fccbb79&scoped=true&"
var script = {}
import style0 from "./awards.vue?vue&type=style&index=0&id=4fccbb79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fccbb79",
  null
  
)

export default component.exports